export const GET_TYPES = 'GET_TYPES'
export const GET_POKEMONS = 'GET_POKEMONS'
export const GET_POKEMON_DETAIL = 'GET_POKEMON_DETAIL'
export const POST_POKEMON = 'POST_POKEMON'
export const EDIT_POKEMON = 'EDIT_POKEMON'
export const DELETE_POKEMON = 'DELETE_POKEMON'
export const GET_RANDOM_POKEMON = 'GET_RANDOM_POKEMON'

export const CLEAN_DETAIL_POKEMON = 'CLEAN_DETAIL_POKEMON'
export const CLEAN_RANDOM = 'CLEAN_RANDOM'
export const CLEAN_ALERT = 'CLEAN_ALERT'
export const CLEAN_STATUS = 'CLEAN_STATUS'

export const POST_ITEM_HALL = 'POST_ITEM_HALL'
export const DELETE_ITEM_HALL = 'DELETE_ITEM_HALL'

export const PAGINATION_HOME = 'PAGINATION_HOME'
export const SET_PAGE = 'SET_PAGE'
export const CUSTOM_ALERT = 'CUSTOM_ALERT'
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE'
export const SET_FILTERS_POKEMON = 'SET_FILTERS_POKEMON'
export const REMOVE_FILTERS = 'REMOVE_FILTERS'
